export default __webpack_public_path__ + "static/media/plusonly.8c3ae34f.png";